export default {
  root: '/',
  app: {
    dashboard: 'application',
    users: 'users',
    navigation: 'navigation',
    library: 'library',
    design: 'design',
    colors: 'colors',
    content: 'contents',
    datasources: 'datasources',
    deployment: 'deployment',
    api: 'api',
    cgu: 'cgu',
    privacyPolicy: 'privacyPolicy',
    notification: 'notification',
    analytics: 'analytics',
    segmentation: 'segmentation',
    behaviour: 'behaviour',
  },
  account: {
    account: 'account',
    myaccount: 'myaccount',
    myteam: 'myteam',
    mysettings: 'mysettings',
  },
  admin: {
    admin: 'admin',
    icons: 'icons',
    images: 'images',
    users: 'users',
    profiles: 'profiles',
    applications: 'applications',
  },
  error: {
    error404: '/404',
  },
}
